// extracted by mini-css-extract-plugin
export default {"simple":"Simple_simple__1AxzV","listWrpr":"Simple_listWrpr__ogICl","sec":"Simple_sec__fdC6S","pill":"Simple_pill__8D8oI","text":"Simple_text__BBiQc","bgImg":"Simple_bgImg__2Cs34"};